import { render } from "./Results.vue?vue&type=template&id=3a4d7ccb&scoped=true"
import script from "./Results.vue?vue&type=script&lang=js"
export * from "./Results.vue?vue&type=script&lang=js"

import "./Results.vue?vue&type=style&index=0&id=3a4d7ccb&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a4d7ccb"]])

export default __exports__